import { useMemo } from 'react';

import { ROUTES } from 'shared/constants';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

import { useGetFormattedSettings } from './useGetFormattedSettings';

export const useGetDisabledRoutes = () => {
  const { data } = useGetFormattedSettings();
  const { isCurrentAccountObserver, paymentRoutesDisabled } = useAccessibleAccounts();

  return useMemo(() => {
    const disabledRoutesArray = [];

    if (!data?.directDebitEnabled) {
      disabledRoutesArray.push(ROUTES.DIRECT_DEBIT);
    }

    if (data?.visual?.showStatements === false) {
      disabledRoutesArray.push(ROUTES.STATEMENTS);
    }

    if (data?.disableOneOffPayments) {
      disabledRoutesArray.push(ROUTES.MAKE_PAYMENT);
    }

    if (!data?.reEnrolment.isEnabled) {
      disabledRoutesArray.push(
        ROUTES.RE_ENROLMENT_OPTIONS,
        ROUTES.RE_ENROLMENT_CONFIRMATION,
        ROUTES.RE_ENROLMENT_CONTRACT
      );

      if (!paymentRoutesDisabled) {
        disabledRoutesArray.push(ROUTES.RE_ENROLMENT);
      }
    }

    if (paymentRoutesDisabled) {
      disabledRoutesArray.push(
        ROUTES.HOME,
        ROUTES.INVOICES,
        ROUTES.PAYMENTS,
        ROUTES.MAKE_PAYMENT,
        ROUTES.DIRECT_DEBIT,
        ROUTES.BOLETO_PAYMENT,
        ROUTES.STATEMENTS,
        ROUTES.SUCCESS_PAYMENT
      );
    }

    if (isCurrentAccountObserver) {
      disabledRoutesArray.push(
        ROUTES.MAKE_PAYMENT,
        ROUTES.DIRECT_DEBIT,
        ROUTES.BOLETO_PAYMENT,
        ROUTES.STATEMENTS,
        ROUTES.SUCCESS_PAYMENT,
        ROUTES.RE_ENROLMENT,
        ROUTES.RE_ENROLMENT_OPTIONS,
        ROUTES.RE_ENROLMENT_CONFIRMATION,
        ROUTES.RE_ENROLMENT_CONTRACT,
        ROUTES.CONTACT_US
      );
    }

    return disabledRoutesArray;
  }, [
    data?.directDebitEnabled,
    data?.disableOneOffPayments,
    data?.reEnrolment.isEnabled,
    data?.visual?.showStatements,
    paymentRoutesDisabled,
    isCurrentAccountObserver
  ]);
};
